import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import McqResultCard from "./McqResultCard";
Chart.register(...registerables);

const DifficultyChart = ({ data }) => {
  console.log(" my all Data", data);

  const canvasRef = useRef(null);
  let chartInstance = useRef(null);
  const [open, setOpen] = React.useState(false);
  const [selectedPoint, setSelectedPoint] = React.useState(null);
  useEffect(() => {
    // Destroy previous chart instance before creating a new one
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = canvasRef.current.getContext("2d");

    // Compute dynamic min & max for y-axis
    const values = data?.values || [];
    const minY = Math.floor(Math.min(...values, 0.0));
    const maxY = Math.ceil(Math.max(...values, 2.0));

    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: data?.labels,
        datasets: [
          {
            label: "Ability Score Path",
            data: values,
            backgroundColor: "#4635B1",
            borderColor: "#4635B1",
            borderWidth: 3,
            pointBackgroundColor: data.isCorrect.map((val) => (val < 1 ? "red" : "#00FF9C")),
            pointRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            type: "category",
            grid: {
              color: "rgba(0, 0, 0, 0.5)",
            },
            ticks: {
              color: "black",
            },
          },
          y: {
            type: "linear",
            min: minY,
            max: maxY,
            ticks: {
              stepSize: 0.5, // Set a smaller step size for more detailed tick marks
              callback: function (value) {
                return value.toFixed(1); // Display as decimal (e.g., 0.5, 1.0, 1.5, etc.)
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.4)",
            },
          },
        },
        onClick: (event, elements) => {

          if (elements.length > 0) {
            const { index, datasetIndex } = elements[0];
            const clickedData = {
              label: data.labels[index],
              value: values[index],
              isCorrect: data.isCorrect[index],
              data: data.data[index],
            };
            setSelectedPoint(clickedData);
            setOpen(true);
          }
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          width: "950px",
          maxHeight: "400px"
        }}
      ></canvas>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, ml: 1, color: "#f97e00" }}>
          Question Detail
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpen(false);
              setSelectedPoint(null);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedPoint ? (
            <>
              <McqResultCard
                data={selectedPoint.data}
                isCorrect={selectedPoint.isCorrect}
                label={selectedPoint.label}
              />
            </>
          ) : (
            <Typography>No data available</Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DifficultyChart;
